/**
 * 14 European allergens mapped to icons in public/allergens.
 * Single source of truth: replace default EU allergens with the SVGs saved in the frontend public allergens folder.
 */
const ALLERGENS_BASE = '/allergens';

export const PUBLIC_ALLERGENS = [
  { code: 'A', name: 'Gluten', nameIt: 'Glutine', icon: `${ALLERGENS_BASE}/007-gluten.svg` },
  { code: 'B', name: 'Crustaceans', nameIt: 'Crostacei', icon: `${ALLERGENS_BASE}/036-shellfish.svg` },
  { code: 'C', name: 'Eggs', nameIt: 'Uova', icon: `${ALLERGENS_BASE}/005-egg.svg` },
  { code: 'D', name: 'Fish', nameIt: 'Pesce', icon: `${ALLERGENS_BASE}/006-fish.svg` },
  { code: 'E', name: 'Peanuts', nameIt: 'Arachidi', icon: `${ALLERGENS_BASE}/033-peanut.svg` },
  { code: 'F', name: 'Soybeans', nameIt: 'Soia', icon: `${ALLERGENS_BASE}/037-soybean.svg` },
  { code: 'G', name: 'Milk', nameIt: 'Latte', icon: `${ALLERGENS_BASE}/012-milk.svg` },
  { code: 'H', name: 'Nuts', nameIt: 'Frutta a guscio', icon: `${ALLERGENS_BASE}/008-hazelnut.svg` },
  { code: 'I', name: 'Celery', nameIt: 'Sedano', icon: `${ALLERGENS_BASE}/002-celery.svg` },
  { code: 'J', name: 'Mustard', nameIt: 'Senape', icon: `${ALLERGENS_BASE}/013-mustard.svg` },
  { code: 'K', name: 'Sesame', nameIt: 'Semi di sesamo', icon: `${ALLERGENS_BASE}/035-sesame.svg` },
  { code: 'L', name: 'Sulphur dioxide', nameIt: 'Anidride solforosa e solfiti', icon: `${ALLERGENS_BASE}/039-sulfite.svg` },
  { code: 'M', name: 'Lupin', nameIt: 'Lupini', icon: `${ALLERGENS_BASE}/010-leaf.svg` },
  { code: 'N', name: 'Molluscs', nameIt: 'Molluschi', icon: `${ALLERGENS_BASE}/036-shellfish.svg` },
] as const;

/** Icon path for an allergen by code (A–N). Accepts string | undefined. */
export function getPublicAllergenIconPath(code: string | undefined): string | undefined {
  if (code == null || typeof code !== 'string') return undefined;
  const row = PUBLIC_ALLERGENS.find((a) => a.code === code.toUpperCase());
  return row?.icon;
}

/** Whether the icon should be rendered as an image (path or URL). */
export function isAllergenIconImage(icon: string | undefined): boolean {
  if (!icon || typeof icon !== 'string') return false;
  return icon.startsWith('/') || icon.startsWith('http') || icon.includes('cloudinary');
}
